import React from "react";
import ReactDOM from "react-dom";
import App from "../components/Map/App";

const renderMap = ($) => {
	const mapElement = $("#js-map-app")[0];
	// the centre of the map is input on the map page on the CMS
	const parsedCentre = $.parseJSON(mapElement.dataset.centre);
	// check that differentiates between the regular map and the new food map
	const isNewFood = $.parseJSON(mapElement.dataset.newfood);

	// hard coding in a default centre of the map, otherwise the map will break;
	// if the admin inputs a centre on the map page then this will be overwritten
	let props = { centre: [43.634562018974684, -79.41577393257202], isNewFood };

	if (parsedCentre && parsedCentre.latitude && parsedCentre.longitude) {
		const { latitude, longitude } = parsedCentre;
		const centre = [latitude, longitude];
		props.centre = centre;
	}

	if (mapElement) {
		ReactDOM.render(<App {...props} />, mapElement);
	}
};

export default renderMap;